import type { RouteRecordRaw } from 'vue-router'

export const billingRoutes: RouteRecordRaw[] = [
  {
    path: '/billing/dashboard',
    name: 'billing-dashboard',
    component: () => import('./dashboard/pages/BillingDashboardPage.vue')
  }
]
